/* PagingOsPlanFeed.js */

"use strict";
const PagingFeed = require("../../../../lib/PagingFeed");

class PagingOsPlanFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startOsUpgradePlansFeed(this._userSession.activeOrganization.id, this._filter, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2
        });
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadOsUpgradePlanIdsForSelection(tenantId, selection);
    }

    getOsPlanEntitiesById(ids) {
        return this.getEntitiesByIdAsProm(ids);
    }

    getOsPlanEntitiesNameById(ids) {
        return this.getEntitiesValueByIdAsProm(ids, "name");
    }

    getOsPlanEntityById(id) {
        return this.getEntityById(id);
    }
}

module.exports = PagingOsPlanFeed;
